import { FC, ReactNode } from "react"
import GridMUI, { GridProps as MUIGridProps } from "@mui/material/Grid"
import classNames from "classnames"

interface GridProps {
   children: ReactNode
   columns?: MUIGridProps["columns"]
   direction?: MUIGridProps["direction"]
   flexWrap?: MUIGridProps["flexWrap"]
   justifyContent?: MUIGridProps["justifyContent"]
   columnGap?: number | string
   rowGap?: number | string
   sx?: MUIGridProps["sx"]
   className?: MUIGridProps["className"]
}

const Grid: FC<GridProps> = ({
   children,
   direction = "row",
   columns = 12,
   columnGap = 3,
   rowGap = 3,
   className,
   ...rest
}) => {
   return (
      <GridMUI
         className={classNames("grid", className)}
         container
         direction={direction}
         columns={columns}
         columnSpacing={columnGap}
         rowSpacing={rowGap}
         {...rest}
      >
         {children}
      </GridMUI>
   )
}

export default Grid
